/* eslint-disable react/forbid-elements */
import * as React from 'react';

export const CommunicationWaitIllustration: React.FC = () => {
  return (
    <svg viewBox="0 0 340 216" height="100%" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#a)">
        <path fill="#fff" d="M340 0H0v216h340z" />
        <path
          d="m320.162-1.227-5.92 193.418"
          stroke="#006CFD"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m80 26.509 16 3.927M213.72 40.624l53.324-16.079L294 84.065l-66.494 32.568c-36.013 17.645-78.348 17.26-114.048-1.019L43 79.517l5.319-11.456M257.982 166.909s3.779 13.759.994 23.662c-2.135 7.636-6.405 12.817-9.976 13.647"
          stroke="#031D40"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M253 185.564c-.144 5.91-.21 13.411-5.396 20.611-3.169 4.395-8.604 3.919-8.604 3.919M154 12.623s-12.579-8.22-29.482-6.494C112.584 7.34 104 15.21 104 18.347c0 2.868 2.288 3.253 2.288 3.253"
          stroke="#031D40"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M246 185.564c-.234 8.08-3.349 26.684-13.308 26.507-1.748-.037-2.795-.881-2.684-2.567"
          stroke="#031D40"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M237.841 185.653c1.35 7.212-6.117 29.875-14.573 27.18-3.406-1.088-2.442-4.467-.579-8.313 4.331-8.921 7.159-16.919 6.632-23.865"
          stroke="#031D40"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M223.175 166.909s-1.718 6.968-5.661 20.47c-2.283 7.838 3.486 12.707 8.486 8.298M208 113.891a131.095 131.095 0 0 1-16 2.945"
          stroke="#031D40"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m149 28.001 5.36-15.238 73.422 36.01 20 33.187s5.025 8.735 5.049 14.82c.013 6.086 4.169 70.129 4.169 70.129h-34.304l4.95-61.761s-7.196 4.38-19.392 8.06l-15.818-50.375c18.027-2.565 27.121-8.65 27.121-8.65l-18.139 5.975-40.346-12.993"
          fill="#006CFD"
        />
        <path
          d="m149 28.001 5.36-15.238 73.422 36.01 20 33.187s5.025 8.735 5.049 14.82c.013 6.086 4.169 70.129 4.169 70.129h-34.304l4.95-61.761s-7.196 4.38-19.392 8.06l-15.818-50.375c18.027-2.565 27.121-8.65 27.121-8.65l-18.139 5.975-40.346-12.993"
          stroke="#006CFD"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M253.996 35.312c-6.432 3.226-25.854 12.878-25.854 12.878s-1.292 8.568 3.925 18.38c6.267 11.806 16.485 14.92 16.485 14.92l17.067-13.849s2.457 3.176 5.799.8c2.482-1.76.076-5.072.076-5.072s13.168-6.636 6.736-20.535c-4.216-9.097-12.699-13.234-21.423-8.383"
          stroke="#031D40"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M272 37.258s-7.757 2.976-13.593-1.176L256 34.364M270.909 63.818s-5.116-7.645-3.642-15.774c.812-4.47 4.733-9.753 4.733-9.753M263 43.2s-2.754 2.114-3.282 2.185c-.539.06-4.547-.962-5.508-.225-.961.736 1.688 3.93 1.688 3.93M257 40.255v.951-.952zM263.486 49.09s-.919.708-.23.944c.689.236 1.148-.678.23-.943z"
          stroke="#031D40"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M281.974 39.273s-1.841 2.147-.461 2.836c1.381.688 2.291-2.065.461-2.836z"
          stroke="#031D40"
          strokeWidth="14.019"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m267 24.545 53 6.873M249.588 47.127c-.527.742-.897 1.878-.224 3.508.662 1.619 1.727 2.203 2.636 2.383"
          stroke="#031D40"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M251.199 63.818s-7.088-4.126-7.198-13.762c-.062-5.934 3.501-10.17 5.798-12.075 1.978-1.638 3.415-2.609 9.201-4.6"
          stroke="#031D40"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M272 37.399s-8.96 3.695-14-3.956c0 0 9.987-4.1 14 3.956z" fill="#031D40" />
        <path
          d="M279.098 47.776s3.264 9.809-2.626 21.245c-4.5 8.752-12.301 15.415-12.301 15.415L256 75.312l8.872-7.223s.472 2.723 3.123 2.561c2.652-.162 3.225.323 4.347-2.598 1.135-2.922-3.072-6.837-3.072-6.837s-5.252-10.741-1.275-17.193c3.977-6.44 6.425-5.706 6.425-5.706l4.678 9.46z"
          fill="#031D40"
          stroke="#031D40"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M120 105.055c-18.705-9.422-58.898-30.48-74.096-38.47a11.035 11.035 0 0 1-5.902-9.956c.2-10.827.86-31.089 2.995-34.15 2.932-4.22 7.162-.349 7.162 2.6 0 2.925-.324 5.166-.324 5.166M132 15.582c-8.505-2.187-17.945-.216-25.065 6.37L85 42.218M122 52.036l9 14.728"
          stroke="#031D40"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M120 104.213c.794.391 1.563.758 2.269 1.113 15.791 7.657 28.394 11.18 44.853 12.244A119 119 0 0 0 192 116.567l-10.612-52.901c-2.949.122-6.062.146-9.338.049l-15.351-23.46-30.624 19.166 4.675 7.62 3.101 1.688L120 104.213z"
          fill="#006CFD"
          stroke="#006CFD"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M152 78.546 74 36.327M47 20.894s3.59-5.671 7.8-1.964c3.063 2.691 2.034 9.543 2.034 9.543"
          stroke="#031D40"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M53 17.948s3.949-5.67 8.58-1.963c3.37 2.69 2.237 9.542 2.237 9.542"
          stroke="#031D40"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M59 15.399s3.949-4.64 8.58-1.607c3.37 2.202 2.237 7.808 2.237 7.808"
          stroke="#031D40"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M67 12.574s4.67-6.58 10.143-2.279c3.985 3.132 2.638 11.088 2.638 11.088L77.875 37.31M117 59.89l6-4.908M132.22 15.71s-14.938 4.583-13.056 12.853c1.523 6.686 10.841 3.267 18.316 0 8.154-3.559 11.52-.836 11.52-.836"
          stroke="#031D40"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="m220 54.552-18.298 6.32L161 47.128" fill="#006CFD" />
        <path
          d="m220 54.552-18.298 6.32L161 47.128"
          stroke="#006CFD"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path d="M220 54s-9.402 6.217-28 8.836L220 54z" fill="#006CFD" />
        <path
          d="M220 54s-9.402 6.217-28 8.836"
          stroke="#006CFD"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinejoin="round"
        />
        <path
          d="M181 63.818c4.128-.179 7.939-.549 11.409-1.06 0 0 13.802-1.558 25.591-7.776M149 28.473l14 20.618M319 32.4l-25 51.054M258 193.418h67M140 193.418h77M9 193.418h134M43 79.527 16 35.346M47 18.164l-30-6.382"
          stroke="#031D40"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="m16.162-1.227-3.92 193.418"
          stroke="#006CFD"
          strokeWidth="2.149"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" transform="matrix(-1 0 0 1 340 0)" d="M0 0h340v216H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
